export const DECIMAL_RADIX = 10;

export const TRUTHY_RESPONSIVE_STRINGS: readonly string[] = ['1', 'true'];

export interface ColumnsSelectorDescriptor {
  /** Fixed preset ids always shown in the quick-pick row alongside the active preset. */
  previewIdFixedList: readonly number[];
  /** Preset shown when no preset is currently set. */
  initialSelectedId: number;
}
